import { css } from "styled-components";

export const ghostFilledStyle = css`
  background-color: var(--button-primary-default) !important;
  border: 1px solid var(--button-primary-default);
  color: var(--text-primary);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-small);

  svg path {
    fill: transparent !important;
    stroke: var(--icon-default) !important;
  }

  &:hover {
    background-color: var(--button-ghost-filled-hover) !important;
    border: 1px solid var(--button-ghost-filled-hover) !important;
    color: var(--text-primary) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--icon-default) !important;
    }
  }

  &:focus {
    outline: none !important;
    background-color: var(--button-primary-default) !important;
    border: 1px solid var(--button-primary-default) !important;
    color: var(--text-primary) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--icon-default) !important;
    }
  }

  &:focus-visible {
    outline: 1px solid var(--button-ghost-focused-border) !important;
    box-shadow: 0px 0px 0px 2px var(--button-focused-shadow) !important;
  }

  &:active {
    background-color: var(--button-ghost-filled-hover) !important;
    border-color: var(--button-ghost-filled-hover) !important;
  }

  &[disabled] {
    background-color: var(--button-primary-default) !important;
    border: 1px solid var(--button-primary-default);
    color: var(--text-primary);
    opacity: 0.7;

    &:hover {
      background-color: var(--button-primary-default) !important;
      border: 1px solid var(--button-primary-default);
      color: var(--text-primary);
      opacity: 0.7;
    }
  }
`;
